import {
    Component, Input, Output, EventEmitter, OnInit, inject,
} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DxButtonModule} from 'devextreme-angular/ui/button';
import {DxToolbarModule} from 'devextreme-angular/ui/toolbar';

import {UserPanelComponent} from '../user-panel/user-panel.component';
import {AuthService, AuthClient, MeDto} from 'src/app/services';
import {ThemeSwitcherComponent} from 'src/app/components/library/theme-switcher/theme-switcher.component';
import {firstValueFrom} from "rxjs";
import {LogoComponent} from "../logo/logo.component";
import {Router} from "@angular/router";

@Component({
    selector: 'app-header',
    templateUrl: 'app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    imports: [
        CommonModule,
        DxButtonModule,
        DxToolbarModule,
        ThemeSwitcherComponent,
        UserPanelComponent,
        LogoComponent,
    ]
})

export class AppHeaderComponent implements OnInit {
    @Output()
    menuToggle = new EventEmitter<boolean>();

    @Input()
    menuToggleEnabled = false;

    @Input()
    title!: string;

    private authService = inject(AuthService);
    private auth = inject(AuthClient);
    private router = inject(Router);

    user: MeDto | null;

    get isImpersonated() {
        return this.authService.isImpersonated;
    }

    userMenuItems = [
        {
            text: 'Profile',
            icon: 'user',
            onClick: async () => {
                await this.router.navigate(['/me']);
            },
        },
        {
            text: 'Logout',
            icon: 'runner',
            onClick: async () => {
                await this.authService.logOut();
            },
        }];

    async ngOnInit() {
        this.user = await firstValueFrom(this.auth.me());
    }

    undoImpersonate() {
        this.authService.undoImpersonate().subscribe(async () => {
            location.reload();
        });
    }

    toggleMenu = () => {
        this.menuToggle.emit();
    };
}
